import { useContext, useMemo } from 'react';
import { Module } from '../api/module';
import IdentityContext from '../contexts/IdentityContext';
import { getModuleAccess } from '../core/access/module-access';
import ModuleContext from '../pages/material/_contexts/ModuleContext';
import useStudioGroup from './useStudioGroup';

export default function useModuleAccess(module: Module | undefined) {
  const { module: superModule } = useContext(ModuleContext);
  const { identity } = useContext(IdentityContext);
  const studioGroup = useStudioGroup();

  return useMemo(
    () => getModuleAccess({ module, superModule, identity, studioGroup }),
    [module, superModule, identity, studioGroup],
  );
}
